import SecureLS from 'secure-ls';
import type { AuthData, User } from '../types/user';

const ls = new SecureLS({ encodingType: 'aes' });

export const isAuthenticated = () => {
  try {
    const authData = ls.get('auth');
    return !!authData?.jwt;
  } catch (error) {
    return false;
  }
};

export const getToken = () => {
  try {
    const authData = ls.get('auth') as AuthData | undefined;
    return authData?.jwt;
  } catch (error) {
    return undefined;
  }
};

export const getUser = (): User | undefined => {
  try {
    const authData = ls.get('auth') as AuthData | undefined;
    return authData?.user;
  } catch (error) {
    return undefined;
  }
};

export const setAuthData = (data: AuthData) => {
  try {
    ls.set('auth', data);
  } catch (error) {
    console.error('Failed to set auth data:', error);
  }
};

export const clearAuthData = () => {
  try {
    ls.remove('auth');
  } catch (error) {
    console.error('Failed to clear auth data:', error);
  }
};